import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Context/AuthProvider";
import TImePicker from "../../../components/common/TImePicker";
import axios from "axios";
import { url } from "../../../Constant";
import { Space, TimePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import { toast } from "react-toastify";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const EditHour = () => {
  const { auth } = useAuth();
  const [workingHours, setWorkingHours] = useState();

  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [time, setTime] = useState();
  const [startTime, setStartTime] = useState("");
  const [extensionNumbers, setExtensionNumbers] = useState();
  const [extesnionSelectionError, setExtesnionSelectionError] = useState("");
  const [daysData, setDaysData] = useState([
    {
      checked: false,
      dayName: "Monday",
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
    {
      dayName: "Tuesday",
      checked: false,
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
    {
      dayName: "Wednesday",
      checked: false,
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
    {
      dayName: "Thursday",
      checked: false,
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
    {
      dayName: "Friday",
      checked: false,
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
    {
      dayName: "Saturday",
      checked: false,
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
    {
      dayName: "Sunday",
      checked: false,
      start_time: "",
      end_time: "",
      option_off_time: "ivr",
      extensions_number: null,
      extesnionValue: null,
    },
  ]);
  const getExtesnions = () => {
    let data = {
      vpbx_id: auth.vpbx_id,
    };
    axios
      .post(url + "get_working_hours_extension_numbers", data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response?.status === 200) {
            if (response?.data?.message === "Data Found") {
              setExtensionNumbers(response?.data?.data?.extension_numbers);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("hours", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getExtesnions();
  }, []);
  useEffect(() => {
    if (workingHours !== undefined) {
      setDaysData([
        {
          checked: false,
          dayName: "Monday",
          start_time: workingHours[0]?.start_time,
          end_time: workingHours[0]?.end_time,
          option_off_time: workingHours[0]?.option_off_time,
          extensions_number:
            workingHours[0]?.option_off_time === "extensions"
              ? workingHours[0]?.extensions_number
              : null,
          extesnionValue: null,
        },
        {
          checked: false,
          dayName: "Tuesday",
          start_time: workingHours[1]?.start_time,
          end_time: workingHours[1]?.end_time,
          option_off_time: workingHours[1]?.option_off_time,
          extensions_number:
            workingHours[1]?.option_off_time === "extensions"
              ? workingHours[1]?.extensions_number
              : null,
          extesnionValue: null,
        },
        {
          checked: false,
          dayName: "Wednesday",
          start_time: workingHours[2]?.start_time,
          end_time: workingHours[2]?.end_time,
          option_off_time: workingHours[2]?.option_off_time,
          extensions_number:
            workingHours[2]?.option_off_time === "extensions"
              ? workingHours[2]?.extensions_number
              : null,
          extesnionValue: null,
        },
        {
          checked: false,
          dayName: "Thursday",
          start_time: workingHours[3]?.start_time,
          end_time: workingHours[3]?.end_time,
          option_off_time: workingHours[3]?.option_off_time,
          extensions_number:
            workingHours[3]?.option_off_time === "extensions"
              ? workingHours[3]?.extensions_number
              : null,
          extesnionValue: null,
        },
        {
          checked: false,
          dayName: "Friday",
          start_time: workingHours[4]?.start_time,
          end_time: workingHours[4]?.end_time,
          option_off_time: workingHours[4]?.option_off_time,
          extensions_number:
            workingHours[4]?.option_off_time === "extensions"
              ? workingHours[4]?.extensions_number
              : null,
          extesnionValue: null,
        },
        {
          checked: false,
          dayName: "Saturday",
          start_time: workingHours[5]?.start_time,
          end_time: workingHours[5]?.end_time,
          option_off_time: workingHours[5]?.option_off_time,
          extensions_number:
            workingHours[5]?.option_off_time === "extensions"
              ? workingHours[5]?.extensions_number
              : null,
          extesnionValue: null,
        },
        {
          checked: false,
          dayName: "Sunday",
          start_time: workingHours[6]?.start_time,
          end_time: workingHours[6]?.end_time,
          option_off_time: workingHours[6]?.option_off_time,
          extensions_number:
            workingHours[6]?.option_off_time === "extensions"
              ? workingHours[6]?.extensions_number
              : null,
          extesnionValue: null,
        },
      ]);
    }
  }, [workingHours]);
  const getWorkingHours = () => {
    let api = "";
    if (auth.role === "2") {
      api = "View_working_hours";
    } else {
      api = "user-View_working_hours";
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            if (
              response.data.message === "Data Not Found" &&
              response.data.data.length === 0
            ) {
              setWorkingHours([]);
            } else if (response.data.message === "Data Found") {
              setWorkingHours(response.data.data);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    getWorkingHours();
  }, []);
  const handleCheckboxChange = (index) => {
    var daysDataTemp = [...daysData];

    daysDataTemp[index]["checked"] = !daysDataTemp[index]["checked"];
    if (daysDataTemp[index]["checked"] === true) {
      daysDataTemp[index]["start_time"] = "00:00";
      daysDataTemp[index]["end_time"] = "00:00";
    } else {
      daysDataTemp[index]["start_time"] = "00:00";
      daysDataTemp[index]["end_time"] = "00:00";
    }
    setDaysData(daysDataTemp);
  };
  const handleDateChange = (index, dateName, e) => {
    var daysDataTemp = [...daysData];
    if (dateName === "start_time") {
      daysDataTemp[index]["start_time"] = moment(e.$d).format("HH:mm");
      setDaysData(daysDataTemp);
    }

    if (dateName === "end_time") {
      daysDataTemp[index]["end_time"] = moment(e.$d).format("HH:mm");
      setDaysData(daysDataTemp);
    }
  };
  const ivrDestination = [
    {
      name: "IVR",
      value: "ivr",
    },
    {
      name: "Extensions",
      value: "extensions",
    },
    {
      name: "Voice mail",
      value: "voicemail",
    },
    // {
    //   name: "Round Robbin",
    //   value: "roundrobbin",
    // },
  ];
  const handleOptionChange = (index, value) => {
    var daysDataTemp = [...daysData];
    if (value === "extensions") {
      daysDataTemp[index]["extensions_number"] = extensionNumbers;
      daysDataTemp[index]["extesnionValue"] = "";
      setDaysData(daysDataTemp);
    } else {
      daysDataTemp[index]["extensions_number"] = null;
      daysDataTemp[index]["extesnionValue"] = null;
      setDaysData(daysDataTemp);
    }
    if (value === "extensions") {
      daysDataTemp[index]["extensions_number"] = extensionNumbers;
      // daysDataTemp[index]["extesnionValue"] = null;
      daysDataTemp[index]["option_off_time"] = value;

      setDaysData(daysDataTemp);
    } else {
      daysDataTemp[index]["extensions_number"] = null;
      daysDataTemp[index]["extesnionValue"] = null;
      daysDataTemp[index]["option_off_time"] = value;
      setDaysData(daysDataTemp);
    }
  };
  const handleExtensionValue = (index, value) => {
    var daysDataTemp = [...daysData];
    daysDataTemp[index]["extesnionValue"] = value;
    setDaysData(daysDataTemp);
  };
  const EditWorkingHours = (e) => {
    e.preventDefault();
    setErrorEnable(true);
    setLoader(true);
    var newData = [];
    daysData.map((val) => {
      newData.push({
        vpbx_id: auth.vpbx_id,
        today: val.dayName,
        start_time: val.start_time,
        end_time: val.end_time,
        option: val.option_off_time,
        extensions: val.extesnionValue,
      });
    });

    let filtereddata = newData.filter((val) => {
      return val.extensions === "";
    });
    var error = "";
    if (filtereddata.length > 0) {
      setExtesnionSelectionError("select extesnion");
      error = "select extesnion";
    } else {
      setExtesnionSelectionError("");
      error = "";
    }

    if (error === "") {
      axios
        .post(
          url + "working_hours",
          { data: newData },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            // console.log('umair', response );
            if (response.status === 200) {
              if (
                response.data.message === "Working hours Updated Successfully"
              ) {
                setLoader(false);
                toast.success("Working hours updated successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/hour";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-1-1">
              <div className="dashboardIntro">
                <Link to="/hour">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX Manager</span>
                </Link>
                <h3>Set Working Hours</h3>
                <p></p>
                {/* <p>
                  Enter details for the new company, add a new user, assign
                  roles, and select teams this user belongs to.
                </p> */}
              </div>
            </div>
          </div>

          <form onSubmit={EditWorkingHours}>
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                {workingHours !== undefined &&
                  daysData.map((day, index) => (
                    <React.Fragment key={index}>
                      <div className="uk-width-1-5@m uk-margin-top">
                        <label className="DateLabel">
                          <b>{day?.dayName}</b>
                        </label>
                        <label className="CheckBoxLabel">
                          <input
                            className="uk-checkbox"
                            type="checkbox"
                            onChange={() => handleCheckboxChange(index)}
                          />
                          <span>{day.checked ? " Closed " : ""}</span>
                        </label>
                      </div>
                      {!day.checked ? (
                        <>
                          <div className="uk-width-1-5@m uk-margin-top">
                            <div className="startTimeInput">
                              {index === 0 && <label>Start time</label>}

                              <Space wrap>
                                <TimePicker
                                  value={
                                    startTime !== ""
                                      ? startTime
                                      : dayjs(day?.start_time, "HH:mm")
                                  }
                                  format={"HH:mm"}
                                  onChange={(e) =>
                                    handleDateChange(index, "start_time", e)
                                  }
                                />
                              </Space>
                            </div>
                          </div>
                          <div className="uk-width-1-5@m uk-margin-top">
                            <div className="endTimeInput">
                              {index === 0 && <label>End time</label>}

                              <Space wrap>
                                <TimePicker
                                  value={dayjs(day?.end_time, "HH:mm")}
                                  format={"HH:mm"}
                                  onChange={(e) =>
                                    handleDateChange(index, "end_time", e)
                                  }
                                />
                              </Space>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="uk-width-1-5@m uk-margin-medium-top">
                            {/* Placeholder for hidden start time field */}
                            <label>OFF Day</label>
                          </div>
                          <div className="uk-width-1-5@m uk-margin-medium-top">
                            {/* Placeholder for hidden end time field */}
                            <label>OFF Day</label>
                          </div>
                        </>
                      )}
                      <div className="uk-width-1-5@m uk-margin">
                        {index === 0 && <label>IVR destination</label>}
                        <select
                          className="uk-select"
                          aria-label="Select"
                          onChange={(e) =>
                            handleOptionChange(index, e.target.value)
                          }
                        >
                          {ivrDestination.map((item, indd) => {
                            return (
                              <option
                                value={item.value}
                                key={indd}
                                selected={day.option_off_time === item.value}
                              >
                                {item.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      <div
                        className={
                          index === 0
                            ? "uk-width-1-5@m editHourMargin"
                            : "uk-width-1-5@m uk-margin"
                        }
                      >
                        {/* <label></label>
                        <br /> */}

                        {day.extensions_number !== null && (
                          <select
                            className="uk-select"
                            aria-label="Select"
                            onChange={(e) => {
                              handleExtensionValue(index, e.target.value);
                            }}
                          >
                            <option value="" selected>
                              Please select extesnion
                            </option>
                            {extensionNumbers.map((val, ind) => {
                              return (
                                <option
                                  key={ind}
                                  value={val}
                                  selected={val == day.extensions_number}
                                >
                                  {val}
                                </option>
                              );
                            })}
                          </select>
                        )}
                      </div>
                      <br />
                    </React.Fragment>
                  ))}
                {errorEnable && extesnionSelectionError !== "" && (
                  <div className="formErrors">please select all extesnions</div>
                )}
                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button className="pinkBtn" type="submit">
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditHour;
